import { styled } from '@mui/material';

export const BackLinkRoot = styled('button')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2px',
  padding: 0,
  border: 'none',
  background: 'transparent',
  fontFamily: 'inherit',
  fontSize: 14,
  fontWeight: 400,
  color: '#808080',
  cursor: 'pointer',
  marginBottom: theme.spacing(3),

  '&:hover': { color: theme.palette.main.black },
}));
